var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1653",
    "data-name": "Group 1653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.389,
    height: 12.389,
    viewBox: "0 0 12.389 12.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 12.389,
    height: 12.389,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M67,70.11a3.1,3.1,0,1,1,3.1-3.086A3.1,3.1,0,0,1,67,70.11",
    transform: "translate(-60.813 -60.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M212.087,115.484c.177,0,.355-.014.531,0a.592.592,0,0,1,.55.6.583.583,0,0,1-.553.592,9.954,9.954,0,0,1-1.062,0,.581.581,0,0,1-.561-.585.592.592,0,0,1,.564-.608c.176-.015.354,0,.531,0,0,0,0,0,0,0",
    transform: "translate(-200.78 -109.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M116.608,212.1a5.233,5.233,0,0,1,0,.531.589.589,0,0,1-.584.536.58.58,0,0,1-.6-.543,9.265,9.265,0,0,1,0-1.086.579.579,0,0,1,.6-.547.589.589,0,0,1,.592.554c.016.184,0,.37,0,.555Z",
    transform: "translate(-109.818 -200.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M115.532,1.08a5.21,5.21,0,0,1,0-.555A.587.587,0,0,1,116.128,0a.576.576,0,0,1,.588.529,9.23,9.23,0,0,1,0,1.11.575.575,0,0,1-.581.537.587.587,0,0,1-.6-.541c-.018-.183,0-.37,0-.555h0",
    transform: "translate(-109.932 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M1.091,116.58c-.169,0-.339.01-.507,0a.6.6,0,0,1-.584-.59.587.587,0,0,1,.566-.6,9.774,9.774,0,0,1,1.038,0,.586.586,0,0,1,.572.6.594.594,0,0,1-.578.6c-.168.012-.338,0-.507,0",
    transform: "translate(0 -109.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M34.35,184.773a.615.615,0,0,1-.61-.334.526.526,0,0,1,.051-.614,9.341,9.341,0,0,1,.818-.82.6.6,0,0,1,.834.835,10.834,10.834,0,0,1-.821.817.768.768,0,0,1-.272.117",
    transform: "translate(-32.037 -174.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M34.457,33.789a1.554,1.554,0,0,1,.343.193c.235.207.454.434.669.663a.6.6,0,1,1-.843.86c-.241-.225-.474-.461-.7-.7a.562.562,0,0,1-.109-.65.631.631,0,0,1,.639-.364",
    transform: "translate(-32.126 -32.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M183.518,35.645a.637.637,0,0,1-.589-.332.535.535,0,0,1,.054-.634,9.37,9.37,0,0,1,.8-.8.6.6,0,0,1,.848.821,10.291,10.291,0,0,1-.818.82.869.869,0,0,1-.3.128",
    transform: "translate(-174.001 -32.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M183.577,182.843a1.567,1.567,0,0,1,.352.194c.236.207.453.435.669.663a.6.6,0,1,1-.852.853c-.239-.227-.474-.461-.7-.7a.555.555,0,0,1-.092-.652.649.649,0,0,1,.619-.354",
    transform: "translate(-174.04 -173.993)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.a80beb3597e39ba5c13b37052c0be587.svg";
export { ForwardRef as ReactComponent };